module.exports = __webpack_public_path__ + "static/media/bike3e.956ad2a8.jpg";